module.exports = __webpack_public_path__ + "static/img/vip-fei-3.5f889a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-fei-3.png
// module id = +duJ
// module chunks = 1